<template>
  <div
    v-if="accountId"
    id="layout"
    :key="forceUpdateLayout"
    class="layout"
  >
    <Header />
    <Alert />
    <router-view />
    <Teleport to="body">
      <ModalBusinessFeatures />
      <UpgradePlanWithoutPermission />
    </Teleport>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component"
import { Watch } from "vue-property-decorator"
import { Getter } from "s-vuex-class"

import Alert from "@/components/Alert/index.vue"
import Header from "@/components/Header/index.vue"
import ModalBusinessFeatures from "@/components/Modal/ModalBusinessFeatures.vue"
import UpgradePlanWithoutPermission from "@/components/Modal/UpgradePlanWithoutPermission.vue"

import { Getters } from "@/store/getters"

@Options({
  components: {
    UpgradePlanWithoutPermission,
    ModalBusinessFeatures,
    Alert,
    Header
  },
  name: "EmptyLayoutWithHeader"
})
export default class EmptyLayoutWithHeader extends Vue {
  @Getter(Getters.GET_CURRENT_ACCOUNT_ID) accountId: string

  forceUpdateLayout = 0

  get triggerUpdate() {
    return this.$route?.meta?.updateComponentByRoute
      ? decodeURI(this.$route.path).replace(/\s/g, "")
      : ""
  }

  @Watch("triggerUpdate")
  onTriggerUpdateChange() {
    if (this.$wait.is("disableUpdateComponentByRoute")) return
    this.forceUpdateLayout++
  }
}
</script>
